import UnderMaintenance from '@/components/templates/underMaintenance/underMaintenanceTemplate'


export default function UnderMaintenacePage() {
    return (
        <div className="under-maintenance-page">
            <UnderMaintenance />
        </div>
    )
}
